import React from 'react';
import { Row, Stack, Text } from 'library/ui';
import { Colors } from 'library';
import styled from '@mui/material/styles/styled';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

export default function CoveredShift({ coveredShifts }: { coveredShifts: { shift_count: number; date: string }[] }) {
    return (
        <Stack gap="sm" padding="sm">
            {coveredShifts.map((coveredShift) => (
                <CoveredBanner key={coveredShift.date} gap="sm" align="center">
                    <VerifiedRoundedIcon style={{ color: Colors.success, fontSize: 20 }} />
                    <Text tone="inherit" weight="bold">
                        {coveredShift.shift_count} sub{coveredShift.shift_count === 1 ? '' : 's'} covered by ELC this
                        day
                    </Text>
                </CoveredBanner>
            ))}
        </Stack>
    );
}

const CoveredBanner = styled(Row)({
    backgroundColor: Colors.successBackground,
    border: `1px solid ${Colors.success}`,
    borderRadius: 12,
    padding: '10px 14px',
    color: Colors.success,
    width: '100%',
});
